import Popover from "@mui/material/Popover";

import { useI18n } from "@/i18n/I18nProvider";

import { MENU_Z_INDEX } from "../navbar.styles";

/*
 * A dropdown anchored under the item that opened it. Menus grow away from the
 * reading edge, so they hang off the left of their trigger in English and off
 * the right in Arabic.
 */
export default function NavPopover({ anchorEl, onClose, offsetTop, children }) {
  const { locale } = useI18n();
  const edge = locale === "en" ? "left" : "right";

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      sx={{ mt: offsetTop, zIndex: MENU_Z_INDEX }}
      anchorOrigin={{ vertical: "bottom", horizontal: edge }}
      transformOrigin={{ vertical: "top", horizontal: edge }}
    >
      {children}
    </Popover>
  );
}
